"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringifyComponents = exports.stringifyComponentValue = void 0;

function stringifyComponentValue(component) {
  if ((component === null || component === void 0 ? void 0 : component.value) === undefined) {
    return '';
  }

  if (typeof (component === null || component === void 0 ? void 0 : component.value) === 'string') {
    return component.value;
  }

  return JSON.stringify(component === null || component === void 0 ? void 0 : component.value);
}

exports.stringifyComponentValue = stringifyComponentValue;

function stringifyComponents(components) {
  const result = {};
  Object.keys(components).forEach(key => {
    result[key] = Object.assign(Object.assign({}, components[key] || {}), {
      value: ''
    });
    result[key].value = stringifyComponentValue(components[key]);
  });
  return result;
}

exports.stringifyComponents = stringifyComponents;